module.exports = __webpack_public_path__ + "static/img/li2_9.5ebf13e1.png";